import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Layout from "@/components/feature/Layout";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Layout>
      <Navbar />
      {children}
      <Footer />
    </Layout>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <PageWrapper>
        <Home />
      </PageWrapper>
    ),
  },
  {
    path: "/category/:slug",
    element: (
      <PageWrapper>
        <CategoryPage />
      </PageWrapper>
    ),
  },
  {
    path: "/article/:id",
    element: (
      <PageWrapper>
        <ArticlePage />
      </PageWrapper>
    ),
  },
  {
    path: "/about",
    element: (
      <PageWrapper>
        <AboutPage />
      </PageWrapper>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

// Lazy imports for pages that are not yet loaded
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import AboutPage from "@/pages/about/page";